$(function () {
  $(".home-chat").click(function () {
    $(".home-suspend-tencent").css("display", "block");
  });

  $(".home-suspend-close").click(function () {
    event.stopPropagation();
    $(".home-suspend-tencent").css("display", "none");
  });

  //展开
  $(".home-chat > span").mouseenter(function () {
    $(".home-chat").addClass("home-chat-active");
  });

  $(".home-chat > span").mouseleave(function () {
    $(".home-chat-active").removeClass("home-chat-active");
  });

  //QQ二维码
  $(".home-suspend-ways > div:nth-child(2)").mouseenter(function () {
    $(".home-suspend-ways > div:nth-child(2) > div").css("display", "block");
  });
  $(".home-suspend-ways > div:nth-child(2)").mouseleave(function () {
    $(".home-suspend-ways > div:nth-child(2) > div").css("display", "none");
  });

  $(".home-suspend-ways > div").on("mouseenter", function () {
    $(".focus").removeClass("focus");
    $(this).addClass("focus");
  });

  $(".home-suspend-ways > div").on("mouseleave", function () {
    $(".focus").removeClass("focus");
  });

  $(".home-suspend-ways > div:nth-child(4)").click(function () {
    $(window).scrollTop(0);
  });

  function draggle() {
    var draggableDiv = document.getElementById("draggable");
    // draggableDiv.style.display = 'none'
    var offsetX, offsetY;
    var isMove = false;

    setTimeout(() => {
      draggableDiv.style.display = "block";
    }, 1000);

    $("#cancel").on("click", function () {
      draggableDiv.style.display = "none";
    });

    $("#contract").on("click", function () {
      draggableDiv.style.display = "block";
    });

    draggableDiv.addEventListener("mousedown", function (event) {
      isMove = true;
      offsetX = event.clientX - draggableDiv.offsetLeft;
      offsetY = event.clientY - draggableDiv.offsetTop;
    });

    document.addEventListener("mousemove", function (event) {
      if (!isMove) {
        return false;
      }
      var x = event.clientX - offsetX;
      var y = event.clientY - offsetY;
      draggableDiv.style.left = x + "px";
      draggableDiv.style.top = y + "px";
    });

    document.addEventListener("mouseup", function () {
      isMove = false;
      offsetX = null;
      offsetY = null;
    });
  }

  



 
  draggle();
});



// WEBPACK FOOTER //
// ./src/components/suspend/suspend.js